var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68146 3H18.3185C18.4506 3 18.5797 3.03814 18.6904 3.10979C18.801 3.18143 18.8883 3.28349 18.9417 3.40357C18.9952 3.52365 19.0123 3.65658 18.9912 3.78619C18.9701 3.9158 18.9116 4.03653 18.8228 4.13368L13.2216 10.2616C13.1076 10.3863 13.0444 10.5489 13.0444 10.7175V15.5149C13.0444 15.6264 13.0167 15.7363 12.9638 15.8347C12.9108 15.933 12.8343 16.0169 12.7409 16.0788L10.0151 17.8862C9.91245 17.9542 9.79318 17.9933 9.66998 17.9992C9.54678 18.0051 9.42427 17.9777 9.31552 17.9198C9.20677 17.8619 9.11586 17.7758 9.05247 17.6705C8.98909 17.5653 8.95561 17.4449 8.95561 17.3222V10.7175C8.95561 10.5489 8.89242 10.3863 8.77839 10.2616L3.17722 4.13368C3.08842 4.03653 3.0299 3.9158 3.00878 3.78619C2.98766 3.65658 3.00485 3.52365 3.05826 3.40357C3.11167 3.28349 3.19899 3.18143 3.30963 3.10979C3.42027 3.03814 3.54944 3 3.68146 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fc2748b9.svg";
export { ForwardRef as ReactComponent };